module.exports = __webpack_public_path__ + "static/media/magic-link-warning.bd0a8a9f.svg";